<template>
	<div class="loginClass">
		<div class="loginContainer">
			<el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="top" label-width="80px"
				class="loginForm">
				<h2 class="loginTitle">用户登录</h2>
				<el-form-item prop="userName">
					<el-input autocomplete="off" prefix-icon="el-icon-user-solid" v-model="loginForm.userName"
						placeholder="用户名" @keyup.enter.native="handleLogin('loginForm')"></el-input>
				</el-form-item>
				<el-form-item prop="passWord">
					<el-input autocomplete="off" prefix-icon="el-icon-lock" type="password" v-model="loginForm.passWord"
						placeholder="密码" @keyup.enter.native="handleLogin('loginForm')" show-password></el-input>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="loginForm.remember" class="rememberPassword">记住密码</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button class="loginBtn" type="primary" @click="handleLogin('loginForm')"
						:loading="loginLoading">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
import { loginApi } from '@/api/login'
export default {
	name: 'Login',
	data() {
		return {
			loginLoading: false,
			loginForm: {
				userName: '',
				passWord: '',
				remember: null,
			},
			loginRules: {
				userName: [
					{ required: true, message: '请输入用户名', trigger: 'blur' },
				], passWord: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],

			}

		}
	},

	mounted() {
		console.log(1);
		
		// console.log('当前机器码:', this.$machineId)
		//清空本地缓存以及VUEX数据
		// this.$store.dispatch('resetStore');
		// 尝试在短延时后再次检查，以应对浏览器异步填充的情况（防止浏览器自动填充密码）  
		// setTimeout(() => {
		// 	this.restoreLoginForm();
		// }, 0);

	},
	methods: {
		handleLogin(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					this.loginLoading = true
					const ty_login = {
						account: this.loginForm.userName,
						password: this.loginForm.passWord,
					}
					const response = await loginApi(ty_login)
					if (response.data.code == "200") {
						//删除本地缓存信息 -- 因为Store的删除只删除state里有的  有的本地不删除
						// if (localStorage.length > 0) {
						// 	for (let i = localStorage.length - 1; i >= 0; i--) {
						// 		if (localStorage.key(i).indexOf('zhiming') != -1) {
						// 			localStorage.removeItem(localStorage.key(i))
						// 		}
						// 	}
						// }
						// 清空 sessionStorage  
						// sessionStorage.clear();
						// 记住密码,先放本地 -- 后续再加接口获取

						// if (this.loginForm.remember) {

						// 	localStorage.setItem('ZMLogin', JSON.stringify(this.loginForm))
						// }

						// //保存登录信息
						// this.$store.commit('getLoginData', response.data.result);
						// //保存账号类型
						// if (response.data.result.role == "教师") {
						// 	this.$store.commit('getLoginType', "teacher");
						// }
						//保存登录token
						// this.$store.commit('getUserTokenData', response.data.result.access_token);
						//给报告占比例排名  (因为进入有时候会显示为null 所以这里先赋值了)
						// if (localStorage.getItem('zhimingReportRank')) {
						// 	this.$store.commit('getReportRank', JSON.parse(localStorage.getItem('zhimingReportRank')));
						// } else {
						// 	this.$store.commit('getReportRank', 25);
						// }
						// //写作的科目只有语文 所以可以直接写死
						// const findSuject = response.data.result.subjects.find(item => item.name.includes('语文'));
						// this.loginLoading = false
						// if (findSuject) {
						// 	this.$store.commit('getSubjectId', findSuject.id)
						// 	this.$router.push('/');
						// } else {
						// 	//说明学科内没有语文不让登录
						// 	this.$message.warning('该账号下没有语文学科,请检查后再登录')
						// }
						localStorage.setItem('zhimingUserTokenData',JSON.stringify(response.data.result))
						this.$router.push('/'); 
					} else {
						this.loginLoading = false
						this.$message({
							type: 'warning',
							message: response.data.message
						});
					}
				} else {
					return false
				}
			})
		},

		//自动填充账号
		// restoreLoginForm() {
		// 	if (localStorage.getItem('ZMLogin')) {
		// 		this.loginForm = JSON.parse(localStorage.getItem('ZMLogin'));
		// 	} else {
		// 		this.loginForm = {
		// 			userName: '',
		// 			passWord: '',
		// 			remember: null,
		// 		}
		// 	}
		// },

	}
}
</script>
<style scoped lang="scss">
.loginClass {
	width: 100%;
	height: 100vh;
	/* 占据整个视口的高度*/
	background: url('../assets/img/loginBG.jpg') no-repeat;
	/* 使背景图片完全填充容器，但不保持宽高比 */
	background-size: 100% 100%;
	/* background-size: cover;   图片覆盖整个元素，保持宽高比 */
	background-position: top;
	/*  就让图片居中 */
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	/* 防止内容滚动 */
	overflow: hidden;

}

.loginContainer {
	background-image: url('../assets/img/formBG.png');
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	background-color: rgba(0, 0, 0, 0.01);
	/* 半透明背景，以便看到背景图片 */
	/* 图片居中 */
	width: 500px;
	padding: 20px;
	background-size: 100% 100%;
	display: flex;
	justify-content: center;
	align-items: center;


	.loginTitle {
		text-align: center;
		color: #ffff;
		margin-bottom: 40px;
	}

	/* 输入框透明 */
	::v-deep .el-input__inner {
		background: rgba(0, 0, 0, 0.01) !important;
		color: #fff !important;
		/* background-color: red; */
	}

	.loginBtn {
		width: 100%;
	}

	.rememberPassword {
		color: #fff;
	}
}
</style>
